module.exports = __webpack_public_path__ + "static/media/blue-plus.fbcf8b78.svg";